import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual} from '../common';

// You are not your Hell™-piece (you ≠ YOU™)
export const you = {
  name: "you",
  header: <span>
    You are not (only) your Hell<sup>™</sup>-piece.
  </span>,
  outside: <span>
    Or: the you/YOU<sup>™</sup> divide: you ≠ YOU<sup>™</sup>.
  </span>,
  preview: <div className="angle-preview">
    <ul>
      <li>‘You’  – if <QL name="reader">reading</QL> this and <i><LRL>understanding</LRL></i> it  – are a <NW>POC</NW>.</li>
      <ul>
        <li>If you are occasionally flipping out (<PL>fear</PL> or <AL name="straitjacket">haste</AL>) or getting <OML name="offensive">offended</OML>, those are elements of <LRL>reactivity</LRL> <i><AL name="handicap">cloaking</AL></i> the self-aware <NW>POC</NW> inside – even if still <AL>sleeping</AL>, even if reduced to a <NW>POCA</NW> <PL name="all.time">for now</PL>.</li>
        <li>‘You’ are an actual <NW>POC</NW>/<NW word="poca">A</NW>, with the <i>ability</i> to <PL>manifest</PL> ‘<NW>God</NW>’.</li>
      </ul>
      <li>Whereas YOU<sup>™</sup> (with <QL name="tm">the ™</QL> is the <AL>Hell</AL><sup>™</sup>-piece. The  <NW word="mns system">MNS-system</NW> <i>pawn</i>.</li>
      <ul>
        <li>YOU<sup>™</sup> is a <i>product</i>. YOU<sup>™</sup> has a ‘dollar value’. If a ‘preacher’ can get some of that <i><NW>money</NW></i>, they will: milk it out of YOU<sup>™</sup> like from a goat: first one titty-Account<sup>™</sup> and then the next; let’s see if we can get some more by squeezing IT<sup>™</sup> like this. They don’t <i>really</i> care about your ‘soul’ (or <NW>POC</NW>). This is the <NW>BOLT</NW>. Either they win, or YOU<sup>™</sup> do; not <i>both</i>.</li>
        <li>If that ‘milking YOU<sup>™</sup> like a goat’ <QL>metaphor</QL> makes you <LRL name="reactivity">react</LRL> (in DISGUST!!!!!!11), that’s not ‘you’ reacting. That’s YOU<sup>™</sup>. The reacto-biological, predictable robot-automaton that we <LRL>as a planet</LRL> are not-so-slowly letting be <AL name="war">take us over</AL>; our potential for <NW>agency</NW> collapsing into <i><PL name="comfort">not thinking</PL></i>. As we <PL>worship</PL> <AL>Hell</AL> (being-apart) and maintain it with ‘<PL>privacy</PL>’.</li>
      </ul>
    </ul>
  </div>,
  text: <div className="angle-text">
    <p>There is furthermore a difference in their <i><AL name="limits">capabilities</AL></i> between ‘you’ and YOU<sup>™</sup>.</p>
    <ul>
      <li>‘You’ – as a <NW>POC</NW>, even if <i>barely</i> thinking – are <PL>non-finite</PL>. [Under construction; itis not justa number n +  because Gippity can WRITE that even if mit does not UNDERSTAND the number)</li>
    </ul>
    <p>Anbove: apparently that ‘broke up’; no idea and the author SUCKS (according to the <PL>human standard</PL>).</p>
  </div>,
};

